module.exports = require("./zh-Hant-TW");